import { LogLevel } from '../types';
/**
 * Checks if a log level is above the global log level.
 * @param level The log level to check
 * @param checkLevel THe log level to check against
 * @returns Is above the checkLevel?
 */
export function isAboveLevel(level, checkLevel) {
    const levels = [LogLevel.Debug, LogLevel.Info, LogLevel.Warn, LogLevel.Error];
    return levels.indexOf(level) >= levels.indexOf(checkLevel);
}
/**
 * Ensures a message output is a string.
 * @param message The message to assert is/convert to a string
 * @returns The message as a string
 */
export function getLogMessage(message) {
    if (typeof message === 'string') {
        return message;
    }
    if (typeof message === 'object' && message !== null) {
        const data = { ...message };
        return JSON.stringify(data);
    }
    return String(message);
}
//# sourceMappingURL=utils.js.map